import request from '@/api/config/request'

const prex = "api/financeiro/declaracao_mensal";

export function listDeclaracoesMensal(eco_codigo, query = {}) {
    return request({
        url: `${prex}/${eco_codigo}`,
        method: 'get',
        params: query
    })
}

export function cancelaDeclaracoesMensal(eco_codigo, dms_codigo) {
    return request({
        url: `${prex}/${eco_codigo}/${dms_codigo}`,
        method: 'delete'
    })
}
